import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../../sharecomponents/vanilladialog.js';
import v from '../../../../utils/Verifiers.jsx';
import AutoCompleteInput from '../../../sharecomponents/AutocompleteImput.jsx';
import ImpresoraDeOrdenesTrabajoasignadas from '../../Vivero/ordenesTrabajoOperativosComponents/ImpresoraDeOrdenesTrabajoasignadas.jsx';
import Totales from './Totales.jsx';
import "./ordenesTrabajoOperativoCampo.css";
import Verifiers from '../../../../utils/Verifiers.jsx';

const OrdenesTrabajoOperativoCampo = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [rendimientos, setrendimientos] = useState([]);
    const [areas, setareas] = useState([]);
    const [ranchos, setranchos] = useState([]);
    const [empleados, setempleados] = useState([]);
    const [empleadosNames, setempleadosNames] = useState([]);
    const [selecciones, setselecciones] = useState({ area: '', labor: '', usuario: "", asignado: 0, fecha_ajustada: "", rancho: '' });
    const [empleadosHash, setempleadosHash] = useState({});
    const [ordenes, setordenes] = useState([]);
    const [fechas, setfechas] = useState({ semana: "", dia: "", semanas: [], dias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'], semana_seleccion: '', dia_seleccion: '' });
    const [diasNoTimbrados, setdiasNoTimbrados] = useState([]);
    const [abrirImpresiones, setabrirImpresiones] = useState(false);
    const [vinculacion, setvinculacion] = useState(null);
    const [laboresNombres, setlaboresNombres] = useState([]);

    useEffect(() => {
        getRendimientos();
    }, []);

    const getRendimientos = async () => {
        const resp = await v.getDataAPI('nomina/oto/rendimientos/campo', {}, setloader, setdialog);
        if (!resp.estatus) return;
        setrendimientos([...resp.data.labores]);
        setareas(resp.data.labores.map((e) => `${e.nombre} - ${e.labores.length} labores`));
        setranchos(resp.data.ranchos);

        setordenes([...resp.data.ordenes]);
        setdiasNoTimbrados({ ...resp.data.edicion_disponible });
        setfechas({
            ...fechas,
            semanas: resp.data.semanas,
            semana: resp.data.semana_actual,
            dia: resp.data.dia_numerico,
            semana_seleccion: resp.data.semana_actual,
            dia_seleccion: resp.data.dia_numerico
        });

        definirEmpleados(resp.data.empleados);
        setvinculacion(resp.data.vinculacion);
        extraerNombresLabores(-1);
    }

    const definirEmpleados = (emps) => {
        setempleados(emps);
        const hash = {};
        emps.forEach(e => { hash[e.nombre] = e; });
        setempleadosHash(hash);
        setselecciones({ ...selecciones, usuario: "" });
        filtrarEmpleados(selecciones.rancho, selecciones.area, emps);
    }

    const filtrarEmpleados = (rancho = selecciones.rancho, area = selecciones.area, emps = [...empleados]) => {
        if (!rancho || rancho === '' || [undefined, null, ""].includes(area)) {
            setempleadosNames([]);
            return;
        }
        const areaNombre = areas[+area]?.split(' - ')[0] ?? "";

        const filtrados = vinculacion ? [...emps] : emps.filter(e => e.rancho === rancho && e.area === areaNombre);
        setempleadosNames(filtrados.map(e => e.nombre).sort());
    }

    const getOrdenesServidor = async (dia = fechas.dia_seleccion, semana = fechas.semana_seleccion, fecha_ajustada = '') => {
        const resp = await v.getDataAPI('nomina/oto/get', { dia, semana, fecha_ajustada, tipo_usuario: "posco" }, setloader, false);
        if (!resp?.estatus) return;
        setordenes([...resp.data.ordenes]);
        definirEmpleados(resp.data.empleados);
        extraerNombresLabores();
    }

    const deleteOrdenBackend = async (id, i, j) => {
        if (!id) { eliminarOrdenLocal(i, j); return; }
        const resp = await v.getDataAPI(`nomina/oto/delete`, { id, force: fechaAjustada() ? true : false }, setloader, setdialog);
        if (!resp?.estatus) return;
        eliminarOrdenLocal(i, j);
    }

    const eliminarOrdenLocal = (i, j) => {
        let newOrds = [...ordenes];
        ordenes[i].labores.splice(j, 1);
        if (ordenes[i].labores.length === 0) newOrds.splice(i, 1);
        setordenes(newOrds);
    }

    const botonImpresiones = () => (<i className={`${ordenes.length > 0 ? 'pointer' : ''} text-red3 ms-3 fa fa-file-pdf`} style={{ transition: "all 1.2s ease-in-out", opacity: ordenes.length > 0 ? 1 : 0 }} title='Abrir generador de impresiones' onClick={() => { if (ordenes.length > 0) setabrirImpresiones(true) }}></i>)

    const rendimiento_info = () => {
        const labor = rendimientos[selecciones?.area ?? '']?.labores[selecciones?.labor ?? ''];
        if (!labor) return (<div className="w text-center w-300 h3 m-0 mb-1 p-0 bg-white contenedor round-top-xl mt-1" id="gridSelecciones" style={{ '--w': '100%', height: "58px", color: "#782E00" }}>ORDENES DE TRABAJO OPERATIVAS <span className='ms-2 me-2 fw-bold' style={{ "fontStyle": "italic" }}>CAMPO</span> {botonImpresiones()}</div>)
        return (<div className="w text-center w-300 h3 m-0 mb-1 p-1 bg-black5 round-top-xl mt-1" id="gridSelecciones" style={{ '--w': '100%', minHeight: "58px" }}>
            <span className='text-bold me-2'>Rendimiento:</span>{labor.unidad_hora} {labor.um} <span className='text-m text-bold text-secondary'>X hora</span>
            <div className="w text-m text-secondary" style={{ '--w': '100%' }}>
                <span className='text-bold me-2'>Tiempo por unidad:</span>
                1 {labor.um}<span className='text-bold me-2 ms-2'>=</span>{+(labor.ms_by_unidad / 60000).toFixed(2)} min.
                <span className='text-bold me-2 ms-2 text-white'>|</span>
                {labor.unidad_hora * 8.5} {labor.um}<span className='text-bold me-2 ms-2'>=</span> 8.5h
                <span className='text-bold me-2 ms-2 text-white'>|</span>
                {labor.unidad_hora * 8} {labor.um}<span className='text-bold me-2 ms-2'>=</span> 8h
                <span className='text-bold me-2 ms-2 text-white'>|</span>
                {+(labor.unidad_hora * 5).toFixed(2)} {labor.um}<span className='text-bold me-2 ms-2'>=</span> 5h
                <span className='text-bold me-2 ms-2 text-white'>|</span>
                {+(labor.unidad_hora * 6).toFixed(2)} {labor.um}<span className='text-bold me-2 ms-2'>=</span> 6h

            </div>
            {botonImpresiones()}
        </div>)
    }

    const tiempo_asignar = () => {
        if (!puedeAgregar()) return "";
        const labor = rendimientos[selecciones?.area ?? '']?.labores[selecciones?.labor ?? ''];
        const ms = labor.ms_by_unidad * selecciones.asignado;
        const hrs = +(ms / 3600000).toFixed(2);
        return ` ${hrs} Horas`;
    }

    const puedeAgregar = () => selecciones.area !== '' && selecciones.labor !== '' && selecciones.usuario !== '' && selecciones.asignado > 0 && selecciones.rancho !== '';

    const agregarALista = () => {
        if (!puedeAgregar()) return;
        let index = buscarEmpleadoEnOrdenes(empleadosHash[selecciones.usuario].id);
        const lbRef = rendimientos[selecciones.area].labores[selecciones.labor];
        const lb = JSON.parse(JSON.stringify(lbRef));
        lb.nomina_rendimiento_id = lb.id;
        const usuario = empleadosHash[selecciones.usuario];
        const asignado = selecciones.asignado;

        let ord = [...ordenes];
        if (index < 0) {
            index = ordenes.length;
            ord.push({
                asignado_a: usuario.id,
                nombre_empleado: usuario.nombre,
                area: rendimientos[selecciones.area].nombre,
                labores: [
                    {
                        labor: { ...lb },
                        asignado: asignado,
                        unidades_realizadas: 0
                    }
                ]
            });

            guardarServidor(lb, usuario.id, asignado, 0, null, selecciones.rancho);
        } else {
            ord[index].labores.push({
                labor: { ...lb },
                asignado: asignado
            });
            guardarServidor(lb, usuario.id, asignado, 0, null, selecciones.rancho);
        }
        setordenes(ord);
        setselecciones({ ...selecciones, asignado: 0, labor: '' });
    }

    const ajustar_cumplimiento = (orden, labor, cantidad) => {
        cantidad = v.numberFormat(cantidad, 0);
        if (cantidad < 0) cantidad = 0;
        const lb = ordenes[orden].labores[labor];
        const usuario_id = ordenes[orden].asignado_a;
        const asignado = lb.asignado;

        guardarServidor(lb.labor, usuario_id, asignado, cantidad, lb.otp_id ?? null);

        let ord = [...ordenes];
        ord[orden].labores[labor].unidades_realizadas = cantidad;
        setordenes(ord);
    }

    const buscarEmpleadoEnOrdenes = (empleadoID) => ordenes.findIndex(e => e.asignado_a === empleadoID);
    const buscar_labor = (labor_id, labs) => labs.findIndex(e => e.labor.id === labor_id);
    const enFechaActual = () => (fechas.semana_seleccion === fechas.semana && +fechas.dia_seleccion === +fechas.dia);

    const guardarServidor = async (lab, asignado_a, asignado = null, unidades_realizadas = null, id = null, srancho = null) => {

        const payload = Array.isArray(lab) ? lab.map(lb => {
            return {
                nomina_rendimiento_id: lb.labor.nomina_rendimiento_id,
                unidades_asignadas: lb.asignado,
                asignado_a: asignado_a,
                unidades_realizadas: lb.asignado,
                id: lb.labor.id
            }
        }) : [{
            nomina_rendimiento_id: lab.nomina_rendimiento_id,
            unidades_asignadas: asignado,
            asignado_a: asignado_a,
            unidades_realizadas: unidades_realizadas,
            id: id
        }];


        const resp = await v.getDataAPI('nomina/oto/add', { ordenes: payload, dia: fechas.dia_seleccion, semana: fechas.semana_seleccion, rancho: srancho }, false, setdialog, 'POST');
        if (!resp?.estatus) {
            getOrdenesServidor();
            return;
        }
        setordenes([...resp.data.ordenes]);
    }

    const barraAvance = (i, j) => {
        const lb = ordenes[i].labores[j];
        const asignado = lb.asignado;
        const relalizado = lb.unidades_realizadas ?? 0;
        const avance = Math.min(100, Math.max(2, (relalizado / asignado) * 100));

        return (<div className="w round-right-xl m-0 p-0" style={{ '--w': `${avance}%`, height: "2px", backgroundColor: colorPorcentaje(avance) }}></div>)
    }

    const colorPorcentaje = (porcentaje) => {
        if (porcentaje < 20) return '#eb1f00ff';
        if (porcentaje < 45) return '#f09800ff';
        if (porcentaje < 90) return '#ded704ff';
        if (porcentaje < 100) return '#00ae06ff';
        return 'rgba(1, 102, 160, 1)';
    }

    const fechaAjustada = (semana = null, dia = null) => {
        semana = semana ?? fechas.semana_seleccion;
        dia = dia ?? fechas.dia_seleccion;
        const ajustable = diasNoTimbrados[semana]?.[dia] ?? false;
        return !ajustable ? false : `${semana}|${dia}`;
    };

    const tiempoPrimerTurno = (contratista) => {
        //if (contratista) return 28800000; // 8 horas
        if (+fechas.dia_seleccion >= 6) return 18000000; // 5 horas
        return 30600000; // 8.5 horas
    }
    const dibujarBarrasAvanceNomina = (labores, contratista) => {
        const tiempo_primer_turno = tiempoPrimerTurno(contratista);
        const tiempo_segundo_turno = 21600000; // 04:00 PM a 10:00 PM (6 horas)
        const nomina = calcularNominas(labores, contratista);

        nomina.primero.realizado = +(nomina.primero.tiempo / tiempo_primer_turno).toFixed(3) * 100;
        nomina.segundo.realizado = +(nomina.segundo.tiempo / tiempo_segundo_turno).toFixed(3) * 100;

        return (<div className={`row d-flex m-0 p-0 justify-content-start w-100`}>
            {barraAvanceTurnos(nomina.primero.realizado, '1º Turno', +nomina.primero.realizado.toFixed(3) + '%')}
            {barraAvanceTurnos(nomina.segundo.realizado, '2º Turno', +nomina.segundo.realizado.toFixed(3) + '%')}
            {barraAvanceTurnos(nomina.bono.total > 0 ? 100 : 0, 'Bono:', '$' + +v.numberFormat(nomina.bono.total, 2).toFixed(2), '')}
        </div>)
    }

    const calcularNominas = (labores, contratista) => {
        let labores_restantes = [];
        const turnos = { primero: { tiempo: 0, registros: [] }, segundo: { tiempo: 0, registros: [[]] }, bono: { total: 0, registros: [] } };
        const tiempo_primer_turno = tiempoPrimerTurno(contratista);
        const resp_t1 = extraerTurno(JSON.parse(JSON.stringify(labores)), tiempo_primer_turno);
        if (resp_t1.realizado >= 0.99) {
            turnos.primero.tiempo = tiempo_primer_turno;
            turnos.primero.registros = resp_t1.labores_incluidas;
            labores_restantes = resp_t1.labores_restantes;
        } else {
            turnos.primero.tiempo = resp_t1.tiempo_realizado;
            turnos.primero.registros = resp_t1.labores_incluidas;
            return turnos;
        }

        if (labores_restantes.length == 0) return turnos;

        let valorRealizado = 0;
        do {
            let turno_02 = extraerTurno(JSON.parse(JSON.stringify(labores_restantes)), 21600000); // 6 horas
            valorRealizado = turno_02.realizado;
            if (valorRealizado >= 0.99) {
                turnos.segundo.tiempo += 21600000;
                turnos.segundo.registros = [...turnos.segundo.registros, ...turno_02.labores_incluidas];
                labores_restantes = turno_02.labores_restantes;
            }
        } while (valorRealizado >= 0.99);

        //Lo que quede va a bono
        if (labores_restantes.length > 0) {
            labores_restantes.forEach(labo => {
                turnos.bono.total += (labo.unidades_realizadas ?? 0) * (labo.labor.pago_unidad ?? 0);
                turnos.bono.registros.push(labo);
            });
        }
        return turnos;
    }

    //Aparta los registros que correspondan com maximo al tiempo indicado
    const extraerTurno = (labores, tiempo) => {
        let tiempo_realizado = 0;
        let labores_incluidas = [];
        let labores_restantes = [];
        let finalizado = false;
        const len = labores.length;

        for (let i = 0; i < len; i++) {
            //Si ya se finalizó el tiempo necesario a cumpllir solo agregamos la labores a las labores restantes
            if (finalizado) {
                labores_restantes.push(labores[i]);
                continue;
            }

            const lab = labores[i];
            const labor = lab.labor;
            const labor_ms_relizados = labor.ms_by_unidad * (lab.unidades_realizadas ?? 0);
            const suma_tiempo_total = labor_ms_relizados + tiempo_realizado;

            //Si el tiempo total de la labor + lo contabilizado es inferior al tiempo objetivo solo suamos la labor completa
            if (suma_tiempo_total <= tiempo) {
                tiempo_realizado += labor_ms_relizados;
                labores_incluidas.push(lab);
                continue;
            }

            //Si el total de la labor + lo contabilizado es igual al tiempo objetivo sumamos y terminamos el ciclo
            if (suma_tiempo_total === tiempo) {
                tiempo_realizado += labor_ms_relizados;
                labores_incluidas.push(lab);
                finalizado = true;
                continue;
            }

            //Si el total realizado excede el tiempo que deberiamos completar dividimos la labor para obtener solo lo necesario
            if (suma_tiempo_total > tiempo) {
                const resp = divirLaborRealizada(tiempo, tiempo_realizado, lab);

                tiempo_realizado += labor.ms_by_unidad * resp.incluida.unidades_realizadas;
                labores_incluidas.push(resp.incluida);
                labores_restantes.push(resp.excedente);

                //Finalizamos el conteo de labores
                finalizado = true;
                continue;
            }
        }
        const total_tiempo_objetivo_realizado = +(tiempo_realizado / tiempo).toFixed(2);
        return { labores_incluidas, labores_restantes, realizado: total_tiempo_objetivo_realizado, tiempo_realizado: tiempo_realizado };
    }

    /**
     * Solo se debe usar en labores que exceden el tiempo objetivo suamndo el tiempo de la labor + el tiempo actual
     * Divide la labor en dos, una que se contiene el cumplimiento necesario para llegar al tiempo objetivo y otra con el excedente 
     * @param {int} tiempo_objetivo tiempo maximo que se debe cubrir 
     * @param {int} tiempo_actual tiempo ya contabilizado
     * @param {object} laborImplicada objeto con la labor y su cumplimiento en formato estandar
     * @returns {object} objeto con las dos labores divididas en incluida y excedente
     */
    const divirLaborRealizada = (tiempo_objetivo, tiempo_actual, laborImplicada) => {
        const labor_incluida = { asignado: 0, unidades_realizadas: 0, labor: { ...laborImplicada.labor } };
        const labor_excedente = { asignado: 0, unidades_realizadas: 0, labor: { ...laborImplicada.labor } };

        const ms_by_unidad = laborImplicada.labor.ms_by_unidad;
        const tiempo_incluido = tiempo_objetivo - tiempo_actual;

        const unidades_incluidas = tiempo_incluido / ms_by_unidad;
        const unidades_excedentes = (laborImplicada.unidades_realizadas ?? 0) - unidades_incluidas;

        labor_incluida.unidades_realizadas = unidades_incluidas;
        labor_excedente.unidades_realizadas = unidades_excedentes;

        return { incluida: labor_incluida, excedente: labor_excedente };
    }

    const barraAvanceTurnos = (avance, nombre, helpText) => (
        <div className={`bw-100 p-0 ms-2 me-2`}>
            <div className="w text-s" style={{ '--w': '100%' }}>{nombre}<span className='ms-1 text-bold'>{helpText}</span></div>
            <div className={`bw-100 round-xxl border text-start p-0 bg-black5`} style={{ overflow: "hidden" }}>
                <div className={`m-0 p-0`} style={{ minHeight: "4px", width: `${avance}%`, backgroundColor: colorPorcentaje(avance), transition: "width 1s ease-in-out", overflow: 'visible' }}></div>
            </div>
        </div>
    )

    const agregarConEnter = (e) => {
        if (selecciones.labor === '' || !enFechaActual() && !fechaAjustada()) return;
        if (e.key === 'Enter') {
            agregarALista();
        }
    }

    const laborRestringida = (lab) => {
        const areaNombre = (lab?.labor?.area_nombre ?? "").toUpperCase();
        return ['VIVERO', ""].includes(areaNombre);
    }

    const extraerNombresLabores = (areaIndex = selecciones.area) => {
        areaIndex = Verifiers.numberFormat(areaIndex, -1);
        areaIndex = parseInt(areaIndex);
        if (areaIndex < 0) {
            setlaboresNombres([]);
        } else {
            const laboresList = (rendimientos[+areaIndex]?.labores ?? []);
            setlaboresNombres(laboresList.map((e) => e.labor));
        }
        setselecciones(prev => ({ ...prev, labor: '' }));
    }

    return (
        <>
            <button className='btn btn-sm border border-warning border2 btn-light shadow bw-100 text-bold round-m border-2'
                onClick={() => {
                    const gridSelecciones = document.getElementById('gridSelecciones');
                    if (gridSelecciones) gridSelecciones.scrollIntoView({ behavior: 'smooth' });
                }}
                style={{ position: 'fixed', bottom: '1rem', right: '1rem', zIndex: 2 }}>Ir arriba</button>
            <div className='w-100 m-0 p-0' style={{ height: "calc(100vh - 100px)", overflowY: 'auto' }}>
                <div className='row justify-content-around w-100 m-0 p-0'>
                    {rendimiento_info()}
                    <div className="gridSelecciones bw blur-m bg-white4" style={{ '--bw': '1600px' }}>
                        <div className="g-column1 m-0 mb-2" >
                            <label className='text-bold w-100 text-center text-s'>SEMANA</label>
                            <select className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                value={fechas.semana_seleccion}
                                onChange={(e) => {
                                    const fajust = fechaAjustada(e.target.value, fechas.dia_seleccion);
                                    setfechas({ ...fechas, semana_seleccion: e.target.value, fecha_ajustada: fajust });
                                    setselecciones({ ...selecciones, fecha_ajustada: fajust });
                                    getOrdenesServidor(fechas.dia_seleccion, e.target.value, fajust);
                                }}>
                                {(fechas?.semanas ?? []).map((e, i) => <option key={'sem' + i} value={e}>{e}</option>)}
                            </select>
                        </div>

                        <div className="g-column2 m-0 mb-2" >
                            <label className='text-bold w-100 text-center text-s'>DÍA</label>
                            <select className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                value={fechas.dia_seleccion}
                                onChange={(e) => {
                                    const fajust = fechaAjustada(fechas.semana_seleccion, e.target.value);
                                    setfechas({ ...fechas, dia_seleccion: e.target.value, fecha_ajustada: fajust });
                                    setselecciones({ ...selecciones, fecha_ajustada: fajust });
                                    getOrdenesServidor(e.target.value, fechas.semana_seleccion, fajust);
                                }}>
                                {(fechas?.dias ?? []).map((e, i) => <option key={'dia' + i} value={i + 1}>{e}</option>)}
                            </select>
                        </div>

                        <div className="g-column1 m-0 mb-2 p-0 text-center contenedor-bottom hide-sm " >
                            <label className={`text-bold  text-center text-xs pt-1 pb-1 ps-3 pe-3 round-s  hide-sm ${fechaAjustada() ? 'bg-primary text-white' : 'bg-black4 opacity-50 text-secondary'}`}>Editable</label>
                        </div>
                        <div className="g-column2 m-0 mb-2" >
                            <label className='text-bold w-100 text-center text-s'>RANCHO</label>
                            <select className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                value={selecciones.rancho}
                                disabled={!enFechaActual() && !fechaAjustada()}
                                onChange={(e) => {
                                    setselecciones({ ...selecciones, rancho: e.target.value, usuario: "" });
                                    filtrarEmpleados(e.target.value, selecciones.area);
                                }}>
                                {selecciones.rancho === '' && <option value='' >Seleccione una opción</option>}
                                {ranchos.map((e, i) => <option key={i} value={e}>{e}</option>)}
                            </select>
                        </div>
                        <div className="g-column3 m-0 mb-2" >
                            <label className='text-bold w-100 text-center text-s'>ÁREA</label>
                            <select className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                value={selecciones.area}
                                disabled={!enFechaActual() && !fechaAjustada()}
                                onChange={(e) => {
                                    setselecciones({ ...selecciones, area: e.target.value, labor: '', usuario: "" });
                                    filtrarEmpleados(selecciones.rancho, +e.target.value);
                                    extraerNombresLabores(+e.target.value);
                                }}>
                                {selecciones.area === '' && <option value='' >Seleccione una opción</option>}
                                {areas.map((e, i) => <option key={i} value={i}>{e}</option>)}
                            </select>
                        </div>

                        <div className="g-column4 m-0 mb-2" >
                            <AutoCompleteInput
                                style="g-column3 relative m-0 mb-2"
                                label="ESCRIBA Y SELECCIONE LA LABOR"
                                inputClass={' round-xs form-control-sm border border-2 shadow-sm text-center contenedor ' + (selecciones.labor === "" ? '' : 'border border-success border-2')}
                                text_class="text-bold w-100 text-s text-center"
                                id="labor-l-input"
                                name="labor-l-input"
                                noResetWhenUseEffect={true}
                                disabled={selecciones.area === '' || !enFechaActual() && !fechaAjustada()}
                                match={laboresNombres}
                                onKeyDown={agregarConEnter}
                                function={(labor_nombre) => {
                                    const index = (rendimientos[selecciones.area]?.labores ?? []).findIndex(e => e.labor === labor_nombre);
                                    if (selecciones.labor !== "") {
                                        if (index < 0) setselecciones({ ...selecciones, labor: '' });
                                    }
                                    else {
                                        if (index !== -1) setselecciones({ ...selecciones, labor: +index });
                                    }

                                    console.log('index', index, 'labor_nombre', labor_nombre,);
                                    /*if (index !== -1) setselecciones({ ...selecciones, labor: index });
                                     else setselecciones({ ...selecciones, labor: '' });*/
                                }}
                            />
                        </div>

                        <AutoCompleteInput
                            style="g-column3 relative m-0 mb-2"
                            label='SELECCIONE UN USUARIO'
                            inputClass={' round-xs form-control-sm border border-2 shadow-sm text-center contenedor ' + (!selecciones.usuario ? '' : 'border border-success border-2')}
                            text_class="text-bold w-100 text-s text-center"
                            id="laborador-input"
                            name="laborador-input"
                            disabled={empleados.length === 0 || selecciones.labor === '' || !enFechaActual() && !fechaAjustada()}
                            match={empleadosNames}
                            onKeyDown={agregarConEnter}
                            function={(selectUser) => {
                                if (empleadosHash[selectUser]) setselecciones({ ...selecciones, usuario: empleadosHash[selectUser].nombre });
                                else setselecciones({ ...selecciones, usuario: '' });
                            }}
                        />

                        <div className="g-column2 m-0 mb-2" >
                            <label className='text-bold w-100 text-center text-xs'>{rendimientos[selecciones?.area ?? '']?.labores[selecciones?.labor ?? '']?.um ?? 'SELECCIONAR LABOR'}</label>
                            <input type='number' className='form-control form-control-sm round-xs border border-2 shadow-sm'
                                value={selecciones.asignado}
                                onChange={(e) => setselecciones({ ...selecciones, asignado: v.numberFormat(e.target.valueAsNumber, 0) })}
                                onKeyDown={agregarConEnter}
                                disabled={selecciones.labor === '' || !enFechaActual() && !fechaAjustada()} />
                        </div>

                        <div className="g-column3 contenedor-bottom pb-2" >
                            <button className={`btn btn-sm btn-${puedeAgregar() ? 'warning shadow border-dark text-bold' : 'light'}  border-2 border round-xs w-100`}
                                disabled={!enFechaActual() && !fechaAjustada() || !puedeAgregar()}
                                onClick={agregarALista}
                                style={{ transition: "all 0.5s ease-in-out" }}>Asignar{tiempo_asignar()}</button>
                        </div>
                    </div>


                    <div className='w-100'></div>

                    {ordenes.length > 0 && <div className="bw p-1" style={{ '--bw': '1250px', overflow: 'auto' }}>
                        <table className='table table-sm'>
                            <thead>
                            </thead>
                            <tbody>
                                {
                                    ordenes.map((e, i) => (
                                        <React.Fragment key={i + 'ord'}>
                                            <tr className='bg-black2 text-white'>
                                                <th scope='row' className='text-bold ps-2 border-bottom border-dark' style={{ fontSize: "15px" }}>
                                                    <div className='row justify-content-between w-100 m-0 p-0'>
                                                        <div className='bw-600'>{e.nombre_empleado} {e.contratista && <span className='text-xxs text-red2 ms-2'>Contratista</span>}</div>
                                                        <div className='bw-200'>
                                                            <button className='btn btn-light btn-sm w-100 shadow p-0 m-0 border-warning border-2 round-0 text-bold'
                                                                onClick={() => {
                                                                    const ordenesFiltradas = e.labores
                                                                        .map(lb => (lb?.labor?.area_nombre ?? "").toUpperCase() !== "VIVERO" ? lb : null)
                                                                        .filter(lb => lb !== null);
                                                                    if (ordenesFiltradas.length === 0) return;
                                                                    guardarServidor(ordenesFiltradas, e.asignado_a);
                                                                }}
                                                            >
                                                                Cumplir todo
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                            <tr className='bg-black2 text-white border-none m-0 p-0'>
                                                <td className='border-none p-0 m-0'>
                                                    <div className="w m-0 pt-0 pe-2 pb-0 bg-white ps-5" style={{ '--w': '100%' }}>
                                                        <table className='table table-sm' style={{ fontSize: "13px" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th scope='col' className='text-secondary'>LABOR</th>
                                                                    <th scope='col' className='text-secondary' style={{ width: "250px" }}>ASIGNADO</th>
                                                                    <th scope='col' className='text-center text-secondary' style={{ width: "160px" }}>REALIZADO</th>
                                                                    <th scope='col' className='text-end pe-3 text-secondary' style={{ width: "180px" }}>HORAS ASIGNADAS</th>
                                                                    <th scope='col' className='border-start text-center text-secondary' style={{ width: "150px" }}>ACCION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    e.labores.map((lab, j) => (
                                                                        <tr key={j + 'lab'}>
                                                                            <td className='nowrap align-middle' style={{ lineHeight: "1" }}>
                                                                                <div className='col-lg-12'>
                                                                                    {lab.labor.labor}
                                                                                    {lab.otp_id === null ? (<span className='text-xs text-bold text-purple3 opacity-70 ms-1'>Ord. siembra</span>) : ''}
                                                                                </div>
                                                                                <div className='col-lg-12'>
                                                                                    {lab.labor.rancho_id && <span className='text-xs opacity-60'>{`${lab.labor.rancho_nombre} - ${lab.labor.area_nombre}`}</span>}
                                                                                </div>


                                                                            </td>
                                                                            <td className='nowrap align-middle' style={{ width: "250px" }}>{lab.asignado} - {lab.labor.um}</td>
                                                                            <td className={'text-center p-0 m-0 nowrap align-middle'} style={{ width: "160px" }}>
                                                                                {lab.otp_id && fechaAjustada() && !laborRestringida(lab) &&
                                                                                    <div className='row justify-content-between w-100 m-0 p-0'>
                                                                                        <input type='number'
                                                                                            className='form-control form-control-sm m-0 pt-0 pb-0 w-55'
                                                                                            value={lab.unidades_realizadas ?? 0}
                                                                                            onChange={(e) => ajustar_cumplimiento(i, j, e.target.value)}
                                                                                        />
                                                                                        <button className='btn btn-sm btn-light shadow-sm border border-warning p-0 text-center mt-1'
                                                                                            onClick={() => {
                                                                                                ajustar_cumplimiento(i, j, lab.asignado)
                                                                                            }}
                                                                                            style={{ 'width': '40%' }}>
                                                                                            Realizar
                                                                                        </button>
                                                                                        <div className="w m-0 p-0 mb-1" style={{ '--w': '100%' }}></div>
                                                                                        {barraAvance(i, j)}
                                                                                    </div>}
                                                                                {(lab.otp_id === null || !fechaAjustada() || laborRestringida(lab)) && `${(lab.unidades_realizadas ?? 0)} - ${lab.labor.um}`}
                                                                            </td>
                                                                            <td className='text-end pe-3 nowrap align-middle' style={{ width: "180px" }}>{+(lab.labor.ms_by_unidad * lab.asignado / 3600000).toFixed(2)} Horas</td>
                                                                            <td className='border-start text-center nowrap align-middle' style={{ width: "150px" }}>
                                                                                <button className={`btn btn-sm btn-${lab.otp_id === null || laborRestringida(lab) ? 'secondary' : 'danger'} border-2 border round-xs p-0 bw-100`}
                                                                                    disabled={(lab.unidades_realizadas ?? 0) > 0 || lab.otp_id === null || laborRestringida(lab)}
                                                                                    onClick={() => laborRestringida(lab) ? () => { } : deleteOrdenBackend(lab.otp_id, i, j)}>
                                                                                    {(lab.otp_id === null || laborRestringida(lab)) ? 'No aplica' : 'Eliminar'}
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                                <tr className='border-none'>
                                                                    <td className='nowrap border-none'>{dibujarBarrasAvanceNomina(e.labores, e.contratista)}</td>
                                                                    <td className='nowrap text-s text-start border-none'>
                                                                        Unidades asignadas:<span className='text-bold text-m text-blue3 ms-1'>{
                                                                            +(e.labores.reduce((total, lab) => total + lab.asignado, 0)).toFixed(2)
                                                                        }<span className='text-s text-300'> Unidades</span>
                                                                        </span>
                                                                    </td>
                                                                    <td className='text-start nowrap text-s border-none'>
                                                                        Total Realizado:<span className='text-bold h5 text-green4 ms-1'>{
                                                                            +(e.labores.reduce((total, lab) => total + (lab.labor.ms_by_unidad * lab.unidades_realizadas), 0) / 3600000).toFixed(2)
                                                                        }<span className='text-s'> Horas</span>
                                                                        </span>
                                                                    </td>
                                                                    <td className='nowrap text-s border-none text-end'>
                                                                        Total asingado:<span className='text-bold h5 text-green4 ms-1'>{
                                                                            +(e.labores.reduce((total, lab) => total + (lab.labor.ms_by_unidad * lab.asignado), 0) / 3600000).toFixed(2)
                                                                        }<span className='text-s'> Horas</span>
                                                                        </span>

                                                                    </td>
                                                                    <td className='text-start ps-2 nowrap h5 border-none' > </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))
                                }
                            </tbody>
                        </table>
                        <Totales ordenes={ordenes} />
                    </div>}
                </div>
            </div >
            {loader ? ldr : null}
            < VainillaDialog data={dialog} />
            {abrirImpresiones && <ImpresoraDeOrdenesTrabajoasignadas ordenes={ordenes} empleados={empleados} close={() => setabrirImpresiones(false)} loader={setloader} />}
        </>

    )
}

export default OrdenesTrabajoOperativoCampo;